import { mergeAttributes, Node } from '@tiptap/core'
import { CONDITIONAL_SPAN_NODE } from '#src/observation-logic/documentUnits.ts'
import {
  CONDITIONAL_ATTRIBUTES,
  nodeAttributes,
} from '#src/tiptap/nodes/shared.ts'

/* A run of inline content (text, observations) shown or hidden together on
 * a condition, inside a line: "Last" and an A1c observation, say. The inline
 * counterpart of a conditional section. */
export const ConditionalSpanNode = Node.create({
  name: CONDITIONAL_SPAN_NODE,
  group: 'inline',
  inline: true,
  content: 'inline*',
  addAttributes() {
    return nodeAttributes(CONDITIONAL_ATTRIBUTES)
  },
  parseHTML() {
    return [{ tag: `span[data-type="${this.name}"]` }]
  },
  renderHTML({ HTMLAttributes }) {
    return [
      'span',
      mergeAttributes(HTMLAttributes, { 'data-type': this.name }),
      0,
    ]
  },
})
